import React from 'react';

export const SectionSeparator = () => {
    return (
        <div className="relative w-full">
            {/* Gradient fade from Hero's bottom color into the Services background */}
            <div
                className="w-full py-16 flex justify-center items-center"
                style={{
                    background: 'linear-gradient(to bottom, hsla(220, 30%, 6%, 0.95) 0%, #0B0F19 100%)'
                }}
            >
                <div className="h-px w-full max-w-xs bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
            </div>
        </div>
    );
};
